import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-photo">
             <img src="/hero.png" alt="Colleen Lavin smiling" />
          </div>
          <div className="hero-copy">
            <h1>COLLEEN LAVIN</h1>
            <blockquote className="pull-quote">
              "Funny and unique... the audience was riotous"
              <cite> — FringeReview</cite>
            </blockquote>
           <div className="about-copy">
            <p>
              Colleen Lavin is a comedian and writer based in Chicago. She got laid off from her tech job on the first night of her honeymoon via a mass Zoom call, which is the kind of thing that builds character and also a new hour of stand-up.
            </p>
            <p>
              Her 2023 Edinburgh Fringe show <em>Do the Robots Think I'm Funny</em> featured an AI she programmed to heckle her in real time. The robot sometimes found her funny. She has chosen to take this at face value and not interrogate it further.
            </p>
          
            <p>
              She's currently workshopping her next hour, <em>This Was Supposed To Be Fun</em>, a show about losing your job, raising your standards, and trying to have fun while everything falls apart.
            </p>
          </div>
            <Link to="/shows" className="btn">View Current Show</Link>
          </div>
        </div>
      </section>

    </>
  );
};

export default Home;
